export default `float s=3.,e;
    for(int i=0;i++<3;p=vec3(2.0,4.0,2.0)-abs(abs(p)*e-vec3(3.0,6.0,1.0)))
      s*=e=1./min(dot(p,p),.6);
    return min(length(p.xz),abs(p.y))/s+.001;
  }`